export default __webpack_public_path__ + "static/media/STL_Intimation_Reg_30.feb4f312.pdf";